/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { IErrorProps } from "../../models";

/**
 *
 * Updates error list ..Pass it the current error, existing Errors for that functionality
 */

export const updateErrorList = (
  err: any,
  currentErrors: Array<IErrorProps>
) => {
  if (!err) return currentErrors;

  let newError: IErrorProps = {
    errorCode:
      err.status ||
      err?.response?.status ||
      err?.data?.code ||
      err?.response?.data?.code,
    errorMessage:
      err.data ||
      err?.response?.data ||
      err?.data?.error ||
      err?.response?.data?.error,
  };

  // now error will come in new format with error,code and status, so need to handle it initially accordingly and leave other handlers as earlier
  // Existing comments below:
  // Error comes in 2 formats one where err.data has message ,  here we need data
  // other where err.data is of Object type. Here we need err.data.title

  //for error code - 400 , 500

  // if (err?.response?.data?.code == 403 || err?.response?.data?.code == 401) {
  //   newError.errorMessage = err.response.data.error;
  //   newError.errorCode = err.response.data.code;
  // } else

  if (newError.errorCode === undefined || newError?.errorCode > 500) {
    newError.errorMessage =
      "An error occurred while processing your request. Please try again later.";
  } else if (typeof err?.data?.error === "string") {
    newError.errorMessage = err?.data?.error;
    newError.errorCode = err?.data?.code;
  } else if (typeof err?.response?.data?.error === "string") {
    newError.errorMessage = err?.response?.data?.error;
    newError.errorCode = err?.response?.data?.code;
  } else if (typeof err?.response?.data === "string") {
    newError.errorMessage = err.response.data;
    newError.errorCode = err.response.status;
  } else if (typeof err?.data === "string") {
    newError.errorMessage = err.data;
  }
  // for error code  - 401
  else if (typeof err?.response?.data?.title === "string") {
    newError.errorMessage = err?.response?.data?.title;
    newError.errorCode = err?.response?.status;
  } else if (typeof err?.data?.status === "number") {
    newError.errorMessage = err?.data?.title;
    newError.errorCode = err?.data?.status;
  } else {
    newError.errorMessage = err.statusText;
    // newError.errorMessage = err?.data?.statusText;
    // newError.errorCode = err?.response?.status;
  }

  let updatedErrorList = [...currentErrors, newError];
  if (currentErrors.some((x) => x.errorMessage === newError.errorMessage)) {
  } else {
    currentErrors = updatedErrorList;
  }

  return currentErrors;
};
export default updateErrorList;

// Need to do something here for error code
